import * as moment from 'moment';

export class DateFormat {
    static formatDate(date) {
        return moment(date).format("D-MMM-YYYY");
    }
    static formatDateTime(dateTime) {
        return moment(dateTime).format("D-MMM-YYYY hh:mm a");
    }
    static toLocalDate(iso8601) {

        let formatted = '';

        if (typeof iso8601 === 'string' && iso8601) {

            const utc = moment.utc(iso8601);

            if (utc.isValid()) {

                formatted = utc.local().format("DD-MMM-YYYY");
            }
        }

        return formatted;
    }
    static toLocalDateAndTime(iso8601) {

        let formatted = '';

        if (typeof iso8601 === 'string' && iso8601) {

            const utc = moment.utc(iso8601);

            if (utc.isValid()) {

                formatted = utc.local().format("DD-MMM-YYYY HH:mm");
            }
        }

        return formatted;
    }
    static toLocalDateFormat(iso8601, format = "YYYY-MM-DD") {

        let formatted = '';

        if (typeof iso8601 === 'string' && iso8601) {

            const utc = moment.utc(iso8601);

            if (utc.isValid()) {

                formatted = utc.local().format(format);
            }
        }

        return formatted;
    }
}


// WEBPACK FOOTER //
// ./src/helpers/date-format.js